import en from './locales/en.json'
import fr from './locales/fr.json'
import nl from './locales/nl.json'
import it from './locales/it.json'
import es from './locales/es.json'
import de from './locales/de.json'
import pt from './locales/pt.json'

export default defineI18nConfig(() => ({
    legacy: false,
    fallbackLocale: 'en-gb',
    missingWarn: false,
    fallbackWarn: false,
    numberFormats: {
        'de-de': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        },
        'en-gb': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        },
        'es-es': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        },
        'fr-fr': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        },
        'it-it': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        },
        'nl-nl': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        },
        'pt-pt': {
            currency: {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            },
            percent: {
                style: 'percent'
            },
            decimal: {
                style: 'decimal',
                maximumFractionDigits: 1
            },
            rating: {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            }
        }
    },
    locale: 'en-gb',
    messages: {
        'en-gb': en,
        'fr-fr': fr,
        'nl-nl': nl,
        'it-it': it,
        'es-es': es,
        'de-de': de,
        'pt-pt': pt
    }
}))
